const TO_HANDLE = 0;
const WAITING_FOR_APPROVAL = 1;
const APPROVED = 2;

export { TO_HANDLE, WAITING_FOR_APPROVAL, APPROVED };
